import xhrService from "../xhrService";

const doctypeGroupsUrl = '/api/tenants/:tenantId/doc-type-groups';

type tenantDoctypeGroupsApiTypes = {
  get: (tenantId: string) => Promise<any>;
  create: (
    tenantId: string,
    data: { name: string; folders: {  doc_type_id: number; name: string, sort_order:number }[] },
  ) => Promise<any>;
  update: (
    tenantId: string,
    groupId: string,
    data: { name: string; folders: {  doc_type_id: number; name: string, sort_order:number }[] },
  ) => Promise<any>;
  delete: (tenantId: string, groupId: string) => Promise<any>;
  getDocTypeGroupItems: (params: {docTypeGroupId: string, tenantId: string}) => Promise<any>;
};

export const tenantDoctypeGroupsApi: tenantDoctypeGroupsApiTypes = {
  get: (tenantId: string) => {
    const endpoint = doctypeGroupsUrl.replace(':tenantId', tenantId);

    return xhrService
      .get(endpoint)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error fetching tenant document type groups:', error);
        throw error;
      });
  },

  getDocTypeGroupItems:({docTypeGroupId, tenantId}: {docTypeGroupId: string, tenantId: string}) => {
    const endpoint = doctypeGroupsUrl.replace(':tenantId', tenantId) + `/${docTypeGroupId}`;

    return xhrService
      .get(endpoint)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error fetching document type group items:', error);
        throw error;
      });

  },
  create: (tenantId: string, data: { name: string; folders: {  doc_type_id: number; name: string, sort_order:number }[] }) => {
    const endpoint  = doctypeGroupsUrl.replace(':tenantId', tenantId);

    return xhrService
      .post(endpoint, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error creating tenant document type group:', error);
        throw error;
      });
  },
  update: (tenantId: string, groupId: string, data: { name: string; folders: {  doc_type_id: number; name: string, sort_order:number }[] }) => {
    const endpoint = doctypeGroupsUrl.replace(':tenantId', tenantId) + `/${groupId}`;

    return xhrService
      .put(endpoint, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error updating tenant document type group:', error);
        throw error;
      });
  },
  delete: (tenantId: string, groupId: string) => {
    const endpoint = doctypeGroupsUrl.replace(':tenantId', tenantId) + `/${groupId}`;

    return xhrService
      .delete(endpoint)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error deleting tenant document type group:', error);
        throw error;
      });
  },
};

